<input
  type="checkbox"
  [formControl]="formControl"
  [formlyAttributes]="field"
  class="form-check-input"
  [ngClass]="props.inputClass"
  [attr.aria-label]="props.ariaLabel | translate"
  [attr.aria-required]="props.required ? 'true' : undefined"
  [attr.aria-invalid]="showError ? 'true' : undefined"
  [attr.aria-describedby]="props.ariaDescribedByIds"
  [attr.data-testing-id]="field.key"
/>
